import React from 'react';

import classNames from 'classnames';

import { colourFor, deriveCode } from './setupHelpers';

/**
 * IB-701 — a single Setup > Policy tile. REAL DATA ONLY: the policy's method (name), its
 * total_cost value chip, and its details as the description. The icon colour + code are auto-
 * derived on the frontend (never persisted). There are deliberately NO invented governance chips.
 * Clicking the tile opens the edit form.
 */
const PolicyTile = ({ policy, onClick }) => (
    <button
        type="button"
        onClick={onClick}
        className="tw-flex tw-min-h-[7.5rem] tw-w-full tw-flex-col tw-gap-3 tw-rounded-lg tw-bg-white tw-p-4 tw-text-start tw-shadow-primary tw-transition-shadow hover:tw-shadow-lg"
    >
        <div className="tw-flex tw-items-start tw-gap-3">
            <span
                className={classNames(
                    'tw-flex tw-h-10 tw-w-10 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-text-sm tw-font-bold',
                    colourFor(policy.id),
                )}
            >
                {deriveCode(policy.method)}
            </span>
            <div className="tw-min-w-0">
                <div className="tw-truncate tw-text-sm tw-font-semibold tw-text-charcoal">{policy.method}</div>
                {policy.total_cost && (
                    <span className="tw-mt-1 tw-inline-flex tw-rounded tw-bg-charcoal-10 tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-text-charcoal-75">
                        {policy.total_cost}
                    </span>
                )}
            </div>
        </div>

        {policy.details && <div className="tw-text-xs tw-text-charcoal-50 tw-line-clamp-3">{policy.details}</div>}
    </button>
);

export default PolicyTile;
